/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amarantos API
 * REST API for the Amarantos construction and infrastructure management platform. Supports both the Panel (web) and App (mobile) clients.
 *
 * OpenAPI spec version: 1.0.0
 */

export type Role = typeof Role[keyof typeof Role];


export const Role = {
  owner: 'owner',
  supervisor: 'supervisor',
  foreman: 'foreman',
  employee: 'employee',
  inspector: 'inspector',
  contact: 'contact',
} as const;
